/**
 * Product overview: slide the panel open and closed instead of snapping.
 *
 * <details> can't transition to its natural height, so the summary click is
 * taken over: on open the element is opened first and its height animated up
 * from the bar; on close the height is animated down and only then is it
 * closed. Clicking again mid-animation reverses from where it is. Visitors who
 * prefer reduced motion get the native toggle.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function toggle(details) {
    var summary = details.querySelector('.product-overview__summary');
    var closing = details.open && !details.classList.contains('is-closing');
    var from = details.getBoundingClientRect().height;

    if (details._overviewAnimation) details._overviewAnimation.cancel();

    if (closing) {
      details.classList.add('is-closing');
    } else {
      details.classList.remove('is-closing');
      details.open = true;
    }
    var to = closing ? summary.getBoundingClientRect().height : details.getBoundingClientRect().height;

    details.style.overflow = 'hidden';
    var animation = details.animate({ height: [from + 'px', to + 'px'] }, { duration: 350, easing: 'cubic-bezier(.4, 0, .2, 1)' });
    details._overviewAnimation = animation;

    animation.onfinish = function () {
      details._overviewAnimation = null;
      details.style.overflow = '';
      if (closing) {
        details.open = false;
        details.classList.remove('is-closing');
      }
    };
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.product-overview__summary');
    if (!summary || reduceMotion.matches || !summary.parentElement.animate) return;
    event.preventDefault();
    toggle(summary.parentElement);
  });
})();
